import * as React from "react"

import { RankingInterface, RankingItem } from "../config/interfaces";

export default ({ rankingTitle, rankingList, className, visibleAll }: RankingInterface) => {

    return (
        <section className={className}>
            <div className="af-ranking">
                <h2 className="af-ranking__title" data-aos="fade-in">{rankingTitle}</h2>
                <div className="af-ranking__fields" data-aos="fade-up">
                    <span className="af-ranking__fields-position">Puesto</span>
                    <span className="af-ranking__fields-name">Nombre de la obra</span>
                    <span className="af-ranking__fields-category">CTG.</span>
                    <span className="af-ranking__fields-town">Municipio</span>
                    <span className="af-ranking__fields-votes">N° Votos</span>
                </div>
                <ul className="af-ranking__list">
                    {rankingList.map((item, index) => (
                        <RankingItem key={index} hidden={index >= 5 && visibleAll ? false : index >= 5 ? true : false} className="af-ranking__list-item" position={item.position} draw_title={item.draw_title} place={item.place} votes={item.votes} category={item.category} />
                    ))}
                </ul>
            </div>
        </section>
    )
}

const RankingItem = ({ position, draw_title, place, votes, category, className, hidden }: RankingItem) => {
    return (
        <li className={`af-ranking-item ${hidden ? "af-ranking-item--hidden" : ""} ${className}`} data-aos="fade-up">
            <span className="af-ranking-item__position">{position}</span>
            <span className="af-ranking-item__name">{draw_title}</span>
            <span className="af-ranking-item__category"><span className="af-ranking-item__field-name">ctg.</span>{category}</span>
            <span className="af-ranking-item__town"><span className="af-ranking-item__field-name">Municipio</span><span className="af-ranking-item__field-value">{place}</span></span>
            <span className="af-ranking-item__votes"><span className="af-ranking-item__field-name">N° Votos</span><span className="af-ranking-item__field-value">{votes}</span></span>
        </li>
    )
}